// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'building-2';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M2.438 7.313h6.374a.75.75 0 0 1 .75.75v9.374H1.689V8.063a.75.75 0 0 1 .75-.75z' />
    <path d='M11.813 17.438h4.5V1.688A1.125 1.125 0 0 0 15.188.563h-6.75a1.125 1.125 0 0 0-1.126 1.125v3.375h1.125M1.688 17.438H.563m15.75 0h1.125M7.313 2.813h3.375m-9 6.75h1.687m2.813 7.875h-2.25v-2.25a1.125 1.125 0 0 1 2.25 0z' />
    <path d='M14.063 17.438h-2.25v-3.375a1.125 1.125 0 1 1 2.25 0z' />
  </g>
);

export const viewBox = '0 0 18 18';
